import './EditModal.scss';

export { default } from './EditModal';
